module.exports = __webpack_public_path__ + "img/La Verne Hairston, Linda Adams, and Chiquita Hudson - 1966.0b7a576c.jpg";